export default "__VITE_ASSET__7T5Ig$XY__"